module.exports = __webpack_public_path__ + "static/img/preview-01.83185c31.webp";